import apiConfig from '../../../shared/config/apiConfig'
import { createBrandApiRequest } from '../../../shared/brand/utils/brandApiUtils'
import { createBrandDocumentPayload } from '../mappers/documentUploadMapper'
import { enterpriseUploadService } from './enterpriseUploadService'

export const createDocumentUploadService = ({
  brandDocumentsEndpoint = apiConfig.brandAPIs?.BRAND_DOCUMENTS,
  brandRequest,
  enterpriseService = enterpriseUploadService,
} = {}) => {
  const { apiKey = '' } = apiConfig
  const request = brandRequest || createBrandApiRequest({ apiKey })

  return {
    // A retry resumes from whichever stage the previous attempt reached:
    // `enterpriseUpload` means AssetHub finished and only the Brand DNA save
    // is left, while `uploadSession` means the multipart upload is partway
    // through and only its missing chunks need resending.
    uploadDocument: async ({
      brand,
      brandDocumentId,
      documentType,
      enterpriseUpload,
      file,
      onProgress,
      onSession,
      uploadSession,
    }) => {
      const upload =
        enterpriseUpload ||
        (await enterpriseService.uploadDocument(
          { brand, documentType, file, uploadSession },
          { onProgress, onSession },
        ))
      onProgress?.(95)

      let asset
      try {
        asset = await request({
          body: createBrandDocumentPayload({
            brand,
            brandDocumentId,
            documentType,
            file,
            upload,
          }),
          endpoint: brandDocumentsEndpoint,
          method: 'post',
        })
      } catch (error) {
        const requestError =
          error instanceof Error
            ? error
            : new Error('Brand DNA could not create the asset.')
        requestError.enterpriseUpload = upload
        throw requestError
      }
      onProgress?.(100)
      return { ...upload, asset }
    },
  }
}

export const documentUploadService = createDocumentUploadService()
